// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/css/news.css
// module id = 141
// module chunks = 0 19 83 147 149